import React from "react";
import "./logout.scss";
import logo from "../../assets/authentication-imgs/main-logo.svg";
import { Grid, TextField, Checkbox, Button } from "@mui/material";


const Logout: React.FC = () => {
  return (
    <div className="logout">
      <div className="main-body d-flex flex-column justify-center">
        {/* <div className="header ">
          <img src={logo} alt="logo" width="202px" />
        </div> */}
        <Grid container className="flex-center-center" >
          <Grid item xs={10} md={6} lg={4} >
        <div className="contant">
          <span className="h2 title fw-700 flex-center-center">See You Again</span>
          <span className="contant-text fw-500 h5 flex-center-center  ">Do Something good today</span>
          <div className="flex-center-center ">
          <button className="btn btn-primary logout-btn ">
            Log in Again
          </button>
          </div>
        </div>
        </Grid></Grid>
        <div className="backgound-image"></div>
      </div>
    </div>
  );
};

export default Logout;
